import React, { useContext, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Container, Grid } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { withStyles } from '@material-ui/styles'
import Overcast from '../svg/overcast.svg'
import Sunny from '../svg/sunny.svg'
import classes from './seasons.module.scss'
import ApiContext from '../../utils/api-context'
import ReactMarkdown from 'react-markdown'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import Image from 'next/image'

const SeasonsTabs = (props) => {
  const [value, setValue] = useState(0)

  const theme = useTheme()
  const { seasons } = props
  const { t, i18n } = useTranslation()
  const router = useRouter()
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  const seasonsRef = useRef(null)

  const handleChange = (event, newValue) => {
    setValue(newValue)
    window.scroll(
      0,
      window.scrollY + seasonsRef.current.getBoundingClientRect().top - 100
    )
  }

  interface StyledTabsProps {
    variant?: 'standard' | 'scrollable' | 'fullWidth'
    value: number
    onChange: (event: React.ChangeEvent<{}>, newValue: number) => void
  }

  interface TabPanelProps {
    children?: React.ReactNode
    index: any
    value: any
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && <>{children}</>}
      </div>
    )
  }

  const Tab = ({ label, id, controls, icon, selected }) => {
    return (
      <button
        aria-controls={controls}
        id={`tab-${id}`}
        onClick={(evt) => {
          handleChange(evt, id)
        }}
        className={`tab ${selected ? 'active' : ''}`}
        type="button"
      >
        {icon}
        {label}
      </button>
    )
  }

  return (
    <div className={classes.tabsWrapper} ref={seasonsRef}>
      <div className="season-tabs">
        {seasons.season_tab.map((season, i) => {
          return (
            <Tab
              key={i}
              label={
                <div>
                  <p>
                    <strong>{season.temperature}&deg;</strong>{' '}
                    <span>{t('average')}</span>
                  </p>
                  <p>{season[`months`]}</p>
                </div>
              }
              id={i}
              controls={`tabpanel-${i}`}
              icon={
                <img
                  src={`${season.icon.url}`}
                  alt={season.icon.alternativeText}
                />
              }
              selected={value === i}
            />
          )
        })}
      </div>
      <div>
        {seasons.season_tab.map((season, i) => {
          return (
            <TabPanel index={value} value={i} key={i}>
              <div className={'tab-panel'}>
                <Image
                  src={season.background.formats.large.url}
                  alt={season.background.alternativeText}
                  width={1440}
                  height={669}
                  layout="responsive"
                  placeholder="blur"
                  blurDataURL={season.background.formats.small.url}
                />
                <div className="container">
                  <div className="tab-title">
                    <p className={'tab-heading'}>
                      <span>{season[`heading_tag`]}</span>
                      {season[`heading`]}
                    </p>
                  </div>
                  <div className={'tab-content'}>
                    <div className={'tab-stats'}>
                      {season.stat_1_num && (
                        <p>
                          <span>{season.stat_1_num}</span>
                          {season[`stat_1`]}
                        </p>
                      )}
                      {season.stat_2_num && (
                        <p>
                          <span>{season.stat_2_num}</span>
                          {season[`stat_2`]}
                        </p>
                      )}
                      {season.stat_3_num && (
                        <p>
                          <span>{season.stat_3_num}</span>
                          {season[`stat_3`]}
                        </p>
                      )}
                    </div>
                    <div
                      className={'tab-info'}
                      dangerouslySetInnerHTML={{ __html: season[`intro`] }}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
          )
        })}
      </div>
    </div>
  )
}
SeasonsTabs.propTypes = {
  seasons: PropTypes.any.isRequired,
}
export default SeasonsTabs
